<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="refundOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('refundingOrder.title') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeRefundOrderModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                {{ $t('refundExportOrder.refundedSuccessfully') }}
              </v-alert>
              <v-layout wrap>
                <v-flex sm12>
                  <v-select
                    :items="reasons"
                    item-value="value"
                    item-text="text"
                    :label="$t('customer.refundReason') + '*'"
                    v-model="selectedReason"
                    :error-messages="errors.collect('refund_reason')"
                    v-validate="'required'"
                    data-vv-name="refund_reason"
                    @input="updateReasons"
                  ></v-select>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    :label="$t('refundExportOrder.moneyAmountLabel') + '*'"
                    v-model="refundData.money_amount"
                    :error-messages="errors.collect('Money amount')"
                    v-validate="'required|decimal:2|between:0.1,' + orderRemainAmount"
                    data-vv-name="Money amount"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    :label="$t('refundExportOrder.refundNoteLabel')"
                    v-model="refundData.refund_note"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    style="padding: 0px"
                    :label="$t('refundingOrder.sendSmsLabel')"
                    v-model="refundData.send_sms"
                    color="indigo"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex sm12>
                  <h5>{{ $t('refundExportOrder.orderTotalAmountLabel', { amount: theOrderTotalAmount }) }}</h5>
                </v-flex>

                <v-flex
                  v-if="refundData.partial_refunds && refundData.partial_refunds.length > 0"
                  xs12
                >
                  <h6>{{ $t('orders.partialRefundsLabel') }}</h6>
                  <ol>
                    <li
                      v-for="(obj, index) in refundData.partial_refunds"
                      :key="index"
                      style="font-size: 14px"
                    >
                      {{ $t('columns.amount') }} ${{ obj.amount }} <span class="px-2">{{ $t('orders.partialRefundAtBy', { date: $options.filters.moment(obj.created_at, 'YYYY-MM-DD hh:mm A'), name: obj.user.full_name }) }}</span>
                    </li>
                  </ol>
                </v-flex>

                <v-flex
                  v-if="refundData.partial_refunds && refundData.partial_refunds.length > 0"
                  sm12
                >
                  <h5>{{ $t('refundingOrder.orderTotalRemainAmountLabel', { amount: orderRemainAmount }) }}</h5>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeRefundOrderModal(), $validator.reset()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="rtl-mr-4pct"
                outline
                color="success"
              >{{ $t('orders.refundTooltip') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'refundOrderModal',
    'closeRefundOrderModal',
    'checkAlert',
    'refundData',
    'refundOrder',
    'loading',
    'theOrderTotalAmount',
    'reasons'
  ],

  data() {
    return {
      loggedInUserData: {},
      selectedReason: null
    }
  },

  watch: {
    refundOrderModal(newVal) {
      if (!newVal) {
        this.selectedReason = null
      }
    }
  },

  computed: {
    // Each partial refund already lowers the order's total (OrderController::applyPartialRefundToOrder()),
    // so the total IS what's left — subtracting the refunds again would count them twice.
    orderRemainAmount() {
      return this.theOrderTotalAmount
    }
  },

  mounted() {
    this.getLoggedInUser()
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    updateReasons() {
      if (this.selectedReason) {
        const reasonObj = this.reasons.find(r => r.value === this.selectedReason)
        if (reasonObj) {
          setTimeout(() => {
            this.refundData.refund_reason = reasonObj.value
            this.refundData.refund_reason_ar = reasonObj.ar
            this.refundData.refund_reason_ku = reasonObj.ku
          }, 0)
        }
      }
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.refundOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/refundingOrder.vue